import React, { FunctionComponent, memo, useState } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import accessoryPackItemStyles from './AccessoryPackItemStyles';
import clsx from 'clsx';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import Checkbox from '@material-ui/core/Checkbox';
import dealPriceAccessor from '../../../../../../common/service/dealPriceAccessor';
import { IPrices } from '../../../../../../../../common/model/IPrice';
import AccessoryPackModal from '../accessoryPackModal/AccessoryPackModal';
import IExtendedAccessory from '../../../../../model/accessories/IExtendedAccessory';
import ConfigurablePrice from '../../../../../../common/components/configurablePrice/ConfigurablePrice';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IAccessoryPackItemProps {
  id: string;
  name: string;
  prices: IPrices;
  selected: boolean;
  accessories: IExtendedAccessory[];
  onClick: (id: string) => void;
  onToggle: (id: string) => void;
}

const AccessoryPackItem: FunctionComponent<IAccessoryPackItemProps> = memo(
  ({ id, selected, name, prices, onClick, accessories, onToggle }) => {
    const styles = accessoryPackItemStyles();
    const {
      platformConfig: { priceDisplay },
    } = usePlatformConfig();
    const [isModalOpen, setModalOpen] = useState(false);
    const primaryPrice = dealPriceAccessor.getPrimaryPrice(prices, priceDisplay);
    const secondaryPrice = dealPriceAccessor.getSecondaryPrice(prices, priceDisplay);
    const isMultiCurrency = useSelector(currentDealSelectors.getIsMultiCurrency);

    return (
      <Box
        display="flex"
        alignItems="flex-start"
        className={clsx([styles.container, { [styles.planSelected]: selected }])}
        data-test={`option:pack:${id}`}
      >
        <Checkbox
          size={'medium'}
          checked={selected}
          onChange={() => onClick(id)}
          data-test={'pack:checkbox'}
          className={styles.checkbox}
        />
        <Box className={styles.titlePriceContainer}>
          <Box mr={2}>
            <Typography>{name}</Typography>
            <Link
              className={styles.priceGuideToggle}
              onClick={() => setModalOpen(true)}
              variant={'helpingText'}
              underline={'always'}
              color={'secondary'}
              data-test={'button:pack:modal'}
            >
              <Translation id="spc.customise.configuratorSummary.button.show" />
            </Link>
          </Box>
          <Box>
            <ConfigurablePrice
              prices={prices}
              display={{ showOrLabel: true }}
              classes={{
                single: { priceText: styles.priceText },
                multi: {
                  container: styles.multiCurrencyContainer,
                  priceText: styles.multiCurrencyPriceText,
                },
              }}
            />
          </Box>
        </Box>
        <AccessoryPackModal
          id={id}
          name={name}
          primaryPrice={primaryPrice}
          secondaryPrice={secondaryPrice}
          accessories={accessories}
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          isSelected={selected}
          onToggle={onToggle}
          priceDisplay={priceDisplay}
          isMulticurrency={isMultiCurrency}
        />
      </Box>
    );
  },
);

export default AccessoryPackItem;
